'use client'

import {
  useModalActiveAccountStore,
  useModalAddListStore,
  useModalArchivePropertyStore,
  useModalDeletePropertyStore,
  useModalDownloadPropertiesXlsxStore,
  useModalPublishOrUnpublishPropertyStore,
  useModalPublishPortalsErrorStore,
  useModalReassignAdviserStore,
  useModalRetrievePropertyStore,
  useModalSearchIdStore,
  useModalShareFileStore,
  useModalUnavailableStore,
  useModalDescriptionTooLongStore,
  useModalShareFileV2Store,
  useModalReassignAdviserV2Store
} from '../../store'

import { ModalSearchId } from './ModalSearchId'
import { ModalReassignAdviser } from './ModalReassignAdviser'
import { ModalDeleteProperty } from './ModalDeleteProperty'
import { ModalArchiveProperty } from './ModalArchiveProperty'
import { ModalDownloadPropertiesXlsx } from './ModalDownloadPropertiesXlsx'
import { ModalShareFile } from './ModalShareFile'
import { ModalPublishOrUnpublishProperty } from './ModalPublishOrUnpublishProperty'
import { ModalAddList } from './ModalAddList'
import { ModalCreateList } from './ModalCreateList'
import { ModalRetrieveProperty } from './ModalRetrieveProperty'
import { ModalUnavailableProperty } from './ModalUnavailableProperty'
import { ModalActiveAccount } from './ModalActiveAccount'
import { ModalPublishErrorsProperty } from './ModalPublishPortalsError'
import { ModalDescriptionTooLong } from './ModalDescriptionTooLong'
import { ModalShareFilePropertyV2 } from './ModalShareFilePropertyV2'
import { ModalReassignAdviserV2 } from './ModalReassignAdviserV2'
import { useModalCreateListStore } from '../../store/modals/modal-create-list.store'
import { useModalRemoveItemListStore } from '../../store/modals/modal-remove-item-list-store'
import { ModalRemoveItemFromList } from './ModalRemoveItemFromList'
/**
 * The ModalsProvider contains modals that are reusable throughout the app and used in different parts of the app, if you created a modal that will be used in several parts of the app, add the modal to this component.
 * This component is called in the root layout
 * The default modal rendering is avoided to avoid executing code not used by the user (such as service calls, status, etc...)
 */

export const ModalsProvider = () => {
  const isOpenSearchIdModal = useModalSearchIdStore((state) => state?.isOpen)

  const isOpenReassignAdviserModal = useModalReassignAdviserStore(
    (state) => state?.modalReassignAdviser?.isOpen
  )

  const isOpenDeletePropertyModal = useModalDeletePropertyStore(
    (state) => state?.modalDeleteProperty?.isOpen
  )

  const isOpenArchiveModal = useModalArchivePropertyStore(
    (state) => state?.modalArchiveProperty
  )

  const isOpenDownloadPropertiesXlsxModal = useModalDownloadPropertiesXlsxStore(
    (state) => state?.modalDownloadPropertiesXlsx
  )

  const isOpenShareFileModal = useModalShareFileStore(
    (state) => state?.modalShareFile?.isOpen
  )

  const isOpenPublishOrUnpublishPropertyModal =
    useModalPublishOrUnpublishPropertyStore(
      (state) => state?.modalState?.isOpen
    )
  const isOpenPublishErrorModal = useModalPublishPortalsErrorStore(
    (state) => state?.modalState?.isOpen
  )

  const isOpenModalAddList = useModalAddListStore(
    (state) => state?.modalAddList?.isOpen
  )
  const isOpenModalRemoveItemFromList = useModalRemoveItemListStore(
    (state) => state?.modalRemoveItemList?.isOpen
  )
  const isOpenModalCreateList = useModalCreateListStore(
    (state) => state?.isOpen
  )

  const isOpenModalRetrieveProperty = useModalRetrievePropertyStore(
    (state) => state?.modalRetrieveProperty?.isOpen
  )

  const isOpenModalUnavailableProperty = useModalUnavailableStore(
    (state) => state?.isOpen
  )

  const isOpenModalActiveAccount = useModalActiveAccountStore(
    (state) => state?.modalActiveAccount?.isOpen
  )

  const isOpenModalDescriptionTooLong = useModalDescriptionTooLongStore(
    (state) => state?.isOpen
  )

  const isOpenModalShareFileV2 = useModalShareFileV2Store(
    (state) => state?.modalShareFileV2?.isOpen
  )

  const isOpenModalReassignedAdviserV2 = useModalReassignAdviserV2Store(
    (state) => state?.modalReassignAdviserV2?.isOpen
  )

  return (
    <>
      {isOpenSearchIdModal && <ModalSearchId />}
      {isOpenReassignAdviserModal && <ModalReassignAdviser />}
      {isOpenDeletePropertyModal && <ModalDeleteProperty />}
      {isOpenArchiveModal && <ModalArchiveProperty />}
      {isOpenDownloadPropertiesXlsxModal && <ModalDownloadPropertiesXlsx />}
      {isOpenShareFileModal && <ModalShareFile />}
      {isOpenPublishOrUnpublishPropertyModal && (
        <ModalPublishOrUnpublishProperty />
      )}
      {isOpenModalAddList && <ModalAddList />}
      {isOpenModalCreateList && <ModalCreateList />}
      {isOpenModalRetrieveProperty && <ModalRetrieveProperty />}
      {isOpenModalUnavailableProperty && <ModalUnavailableProperty />}
      {isOpenModalActiveAccount && <ModalActiveAccount />}
      {isOpenPublishErrorModal && <ModalPublishErrorsProperty />}
      {isOpenModalDescriptionTooLong && <ModalDescriptionTooLong />}
      {isOpenModalShareFileV2 && <ModalShareFilePropertyV2 />}
      {isOpenModalReassignedAdviserV2 && <ModalReassignAdviserV2 />}
      {isOpenModalRemoveItemFromList && <ModalRemoveItemFromList />}
    </>
  )
}

export default ModalsProvider
